import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { PasswordInput } from '../../password/PasswordInput';
import { DATA_FORM_INPUT } from '../../common/data';

export type PasswordProps = VFFieldProps<
  React.ComponentProps<typeof PasswordInput>
>;
export const Password = React.forwardRef<HTMLInputElement, PasswordProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      contentClassName,
      inlineValidation,
      label,
      onChange: customOnChange,
      required,
      disabled,
      readOnly,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (newValue: string | undefined) => {
                let realVal: string | undefined = newValue;
                if (realVal === '') {
                  realVal = undefined;
                }
                const rv = { target: { name, value: realVal } };
                customOnChange ? customOnChange(realVal as any) : onChange?.(rv);
              },
              [customOnChange, onChange, name]
            );
            return (
              <PasswordInput
                {...DATA_FORM_INPUT(name)}
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                onChange={handleChange}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
